module.exports = __webpack_public_path__ + "fonts/iconfont.d8c8d926.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.ttf?t=1571105669105
// module id = zP7Z
// module chunks = 240